(function($) {

	//This stops it from using a get while security is blocking the request
	if (window.location.href.indexOf("login.jsp") === -1) {
		$.getScript('js/resourceHelper.js');}
	
	var message = null;
    var okCallback = null;
    var cancelCallback = null;
    var initialValue = '';
    var regex = null;
    var errmsg = null;
    var width = 300;
    
    var htmlTemplate = '<div class="prompt-dialog-div">' +
    	'<div class="dialog-message"></div>' +
    	'<label for="prompt-response">{{message}}</label><br/>' +
    	'<input type="text" id="prompt-response" style="width: 378px;">' +
    	'</div>';
    
    $.extend({
        promptUser : function(options) {
            var resourceHelper = new ResourceHelper('GeneralResources');
            var dialogID = '#promptDialog';
            var dialogClassContainer = '';
            var title = '';
            var okBtnText = '';
            var cancelBtnText = '';
            
            if (options) {
                if (options.dialogID) {
                    dialogID = options.dialogID;
                }
                
                if (options.title) {
                    title = options.title;
                }
            
                if (options.message) {
                    message = options.message;
                }
                
                if (options.initialValue) {
                	initialValue = options.initialValue;
                }
                
                if (options.checker) {
                	regex = options.checker.regex;
                	errmsg = options.checker.message;
                }
                
                if (options.width) {
                	width = options.width;
                }
                
                if (options.okBtnText) {
                	okBtnText = options.okBtnText;
                }
                
                if (options.cancelBtnText) {
                	cancelBtnText = options.cancelBtnText;
                }
                
                if (options.dialogClassContainer) {
                	dialogClassContainer += options.dialogClassContainer;
                }

                okCallback = options.okCallback;
                cancelCallback = options.cancelCallback;
            }
            
            // get ok and cancel text if not set
            if(okBtnText === '') {
            	okBtnText = resourceHelper.getValue('OK');
            }
            if(cancelBtnText === '') {
            	cancelBtnText = resourceHelper.getValue('Cancel');
            }
            
            var lastDialogDisplayed = $('.ui-dialog:visible');
            
            $(dialogID).dialog({
            	classes: {'ui-dialog' : dialogClassContainer + ' ui-corner-all'},
                title : title,
                width : width,
                modal : true,
                draggable : false,
                resizable : false,
                buttons : {
                    "OK" : {
                    	disabled: true,
                    	'class': 'ok-button',
                        text : okBtnText,
                        click : function() {
                        	var value = $('#prompt-response').val();
                            $(this).dialog('close');

                            if (typeof okCallback === 'function') {
                            	okCallback(value);
                            }
                        }
                    },
	                "Cancel" : {
	                    text : cancelBtnText,
	                    click : function() {  	
	                        $(this).dialog('close');
	                        
	                        if (typeof cancelCallback === 'function') {
	                        	cancelCallback();
	                        }
	                    }
	                }
                },
                open: function() {
                    $(this).html(Mustache.to_html(htmlTemplate, { message: message }));
                    $('#prompt-response').val(initialValue);
                    var okButton = $('.ok-button');
                    
                    if (initialValue !== '') {
                        if (okButton.hasClass('ui-button')) {
                            okButton.button('enable');
                        } else {
                            okButton.removeAttr('disabled');
                        }
                    }
                    
                    $('#prompt-response').focus();
                },
                close: function(event, ui) {
                    $(this).html('');
                }
            });
            
            $('#prompt-response').on('keyup', function() {
                var okButton = $('.ok-button');
                
                var value = $(this).val();
            	if (value.length > 0) {

                	if (!!regex) {
                		if ( ! regex.test(value)) {
                            $('.dialog-message').html(errmsg);
                            $('.dialog-message').removeClass('success');
                            if (okButton.hasClass('ui-button')) {
                                okButton.button('disable');
                            } else {
                                $('.ok-button').attr('disabled', 'disabled');
                            }
                			return;
                		} else {
                            $('.dialog-message').html('');
                            $('.dialog-message').removeClass('success');
                		}
                	}
                    
            		if (okButton.hasClass('ui-button')) {
            	        okButton.button('enable');
            	    } else {
                        okButton.removeAttr('disabled');
            	    }
            	} else {
                    $('.dialog-message').html('');
                    $('.dialog-message').removeClass('success');
                    if (okButton.hasClass('ui-button')) {
                        okButton.button('disable');
                    } else {
                        $('.ok-button').attr('disabled', 'disabled');
                    }
            	}
            } );
        }
    });
})(jQuery);